export type MerchantNavItem = {
  href: string;
  label: string;
  screenId: string;
  icon:
    | 'orders'
    | 'catalogue'
    | 'inventory'
    | 'promotions'
    | 'finance'
    | 'reviews'
    | 'reports'
    | 'team'
    | 'settings';
  /** Show live badge for incoming orders */
  badgeIncoming?: boolean;
};

/** Primary rail — nine 07-03 sections. Kitchen is a floor mode, not a rail item. */
export const MERCHANT_ROOT_NAV: readonly MerchantNavItem[] = [
  {
    href: '/order-board',
    label: 'Orders',
    screenId: 'SCR-MER-050',
    icon: 'orders',
    badgeIncoming: true,
  },
  {
    href: '/catalogue-overview',
    label: 'Catalogue',
    screenId: 'SCR-MER-019',
    icon: 'catalogue',
  },
  {
    href: '/stock-overview',
    label: 'Inventory',
    screenId: 'SCR-MER-031',
    icon: 'inventory',
  },
  {
    href: '/promotion-list',
    label: 'Promotions',
    screenId: 'SCR-MER-037',
    icon: 'promotions',
  },
  {
    href: '/finance-overview',
    label: 'Finance',
    screenId: 'SCR-MER-043',
    icon: 'finance',
  },
  {
    href: '/review-list',
    label: 'Reviews',
    screenId: 'SCR-MER-073',
    icon: 'reviews',
  },
  {
    href: '/trading-dashboard',
    label: 'Reports',
    screenId: 'SCR-MER-076',
    icon: 'reports',
  },
  {
    href: '/staff-list',
    label: 'Team',
    screenId: 'SCR-MER-059',
    icon: 'team',
  },
  {
    href: '/business-settings',
    label: 'Settings',
    screenId: 'SCR-MER-082',
    icon: 'settings',
  },
];
